import React from 'react';
import { Alert } from 'reactstrap';

const StatusText = ({ location }) => {
  const productSlug = location.state && location.state.notFound;
  return productSlug ? <Alert color="danger">No product found with id: {productSlug}</Alert> : null;
}

export default StatusText;